import Productos from '../../../components/ui/Admin/ProductosComponents/Productos';

const ProductosUI = () => {
  return (
    <Productos />
  );
};

export default ProductosUI;
